<template lang="html">
    <div class="navbar">
        <nav class="nav">
            <div class="container">
                <div class="white-text center">
                    <div v-if="user">
                        Bonjour {{user.alias}}
                        <a v-if="user" @click="Logout" class="white-text right" href=""> <i class="material-icons tooltipped" data-position="bottom" data-tooltip="Quitter">exit_to_app</i></a>
                    </div>
                    <ul v-if="isAdmin"class="right">
                        <li>
                            <router-link :to="{ name: 'Home' }" class="blue-text">Accueil général</router-link>
                        </li>
                        <li>
                            <router-link class='blue-text' :to="{ name: 'Admin'}">Administration</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>


    </div>
</template>

<script>
import db from '@/firebase/init'
import firebase from 'firebase'

export default {
    name: 'Navbar',
    data(){
        return{
            //prevent render error
            user: null,
            isAdmin: null
        }
    },
    methods: {
        Logout(){
            firebase.auth().signOut().then(() => {
                this.$router.push({ name: 'Login' })
            })
        }
    },
    created(){
        firebase.auth().onAuthStateChanged((user) => {
            if(user){
                this.user = user

                // get current user from users collection
                let ref = db.collection('users')
                ref.where('user_id', '==', firebase.auth().currentUser.uid).get()
                .then(snapshot => {
                    snapshot.forEach(doc => {
                        this.user = doc.data()
                        this.user.id = doc.id
                    })
                    //check if user is admin
                    if(this.user.role == 'admin'){
                        this.isAdmin = true
                    }
                })
            }else{
                this.user = null
                this.isAdmin = null
            }
        })

    },
}
</script>


<style lang="css" scoped>
nav{
    margin-bottom: 15px;
    background: rgb(0,129,188);
    background: linear-gradient(180deg, rgba(0,129,188,1) 0%, rgba(77,194,224,1) 100%);
}
</style>
